<template>
  <div class="threeShop" ref="threeShop" style="background: #F8F8F8;">
    <div class="softBox">
      <div class="softMarketTop">
        <div class="softMarketTopSearch">
          <div class="logoTitle">
            <div class="logoTitle1">
              宁夏工业企业数字化转型公共服务平台商
            </div>
            <div class="logoTitle2" @click="$router.push('/shopGoodsList')">
              全部商品
            </div>
          </div>
          <div class="searchContainer">
            <div class="flex searchContainerone">
              <el-input
                placeholder="请输入内容"
                v-model="searchValue"
                class="input-with-select"
                @keyup.native.enter="getShopList"
                prefix-icon="el-icon-search"
              >
                <el-button slot="append" @click="getShopList()">
                  搜索
                </el-button>
              </el-input>
              <el-button
                round
                class="searchContainerButton"
                @click="toServiceAuthentication"
                icon="el-icon-s-shop"
              >
                商家入驻
              </el-button>
            </div>

            <ul>
              <li
                class="textLi"
                @click="searchByKeyword(items)"
                v-for="(items, index) in keywords"
              >
                {{ items }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="softMarketBanner">
        <el-carousel
          arrow="never"
          indicator-position="none"
          :interval="5000"
          height="393px"
          class="softCarouselList"
        >
          <el-carousel-item v-for="(item, index) in imgurlList" :key="index">
            <a :href="imgurlList.linkUrl" target="_blank">
              <img
                :src="item.value"
                alt=""
                style="width: 100%;height:393px;"
                ref="image"
              />
            </a>
            <div class="soluBanBox"></div>
          </el-carousel-item>
        </el-carousel>
        <div class="bannerContainer" @mouseleave="leave()">
          <div>
            <div class="bannerContainerLeft">
              <div class="softMarketClassifyContainer">
                <ul>
                  <li
                    v-if="firstList.length > 0"
                    v-for="(item, index) in firstList"
                    :key="index"
                  >
                    <p
                      @mouseenter="btnChoose(item.value, item.children)"
                      @click="handGoodsList(item.value)"
                      style="display: flex;justify-content: space-between;"
                    >
                      <span class="liSpan">{{ item.label }}</span>
                      <i class="el-icon-arrow-right"></i>
                    </p>
                    <div class="secondItem">
                      <div
                        v-if="item.children.length > 0"
                        v-for="(items, indexs) in item.children"
                        :key="indexs"
                        @click="handGoodsList(item.value, items.value)"
                        style="margin-right: 10px;"
                      >
                        <span> {{ items.label }} </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div>
                <div class="softMarketDetails" v-show="show">
                  <div
                    v-for="(item, index) in firstLists"
                    :key="index"
                    class="softMarketList"
                  >
                    <div class="secondName">
                      <span @click="handGoodsList(firstUuids, item.value)">{{
                        item.label
                      }}</span>
                    </div>
                    <div class="threeName">
                      <div v-for="(items, index) in item.children" :key="index">
                        <span
                          @click="
                            handGoodsList(firstUuids, item.value, items.value)
                          "
                          >{{ items.label }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bannerContainerBox">
            <div class="bannerContainerCenter">
              <div class="bannerContainerTop" style="cursor: pointer">
                <el-carousel trigger="click" height="373px">
                  <el-carousel-item
                    v-for="item in bannerList"
                    :key="item.value"
                  >
                    <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
                      <img
                        :src="item.value"
                        alt=""
                        style="width: 698px; height: 373px"
                        ref="image"
                      />
                    </a>
                    <a v-else href="javascript:void(0)">
                      <img
                        :src="item.value"
                        alt=""
                        style="width: 698px; height: 373px"
                        ref="image"
                      />
                    </a>
                    <div class="carouselBtn"></div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <div class="bannerContainerCenterImg" style="cursor: pointer">
              <a :href="rightTopBannerLink" target="_blank"
                ><img :src="rightTopBanner" alt=""
              /></a>
              <a :href="rightBottomBannerLink" target="_blank"
                ><img :src="rightBottomBanner" alt=""
              /></a>
              <a :href="rightCenterBannerLink" target="_blank"
                ><img :src="rightCenterBanner" alt=""
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="shopBox">
      <!-- banner -->
      <div class="bannerBox">
        <a :href="adBannerLink" target="_blank"
          ><img :src="adBanner" alt="" class="bannerMsg"
        /></a>
      </div>
      <div v-for="(item, index) in tabsNap" class="titleTit">
        <div
          v-if="item.fileList.length == 0"
          ref="newmess"
          class="swiperTop dmessages "
          :key="index"
        >
          <div class="flex swiperTopTitle " style="margin-bottom: 16px">
            <div class="flex swiperTopTitleIcon">
              <!-- <p>{{ index+1 }}</p>
              <img src="../../assets/mallTitle.png" alt=""> -->
              <h2>{{ item.categoryName }}</h2>
            </div>
            <div class="flex peopelMess" v-if="index == 0">
              <i class="el-icon-arrow-left" @click="sentimenClick('left')"></i>
              <i
                class="el-icon-arrow-right"
                @click="sentimenClick('right')"
              ></i>
            </div>
            <p class="moreText" v-else @click="handGoodsList()">
              查看更多 >
            </p>
          </div>
          <div class="dmessagesBottom" ref="dmessageRef">
            <div
              class="dmessagesBottombox"
              @click="handGoodsDetails(goodsItem.uuid)"
              v-for="(goodsItem, goodsIndex) in item.goodsList.slice(0, 5)"
              :key="goodsIndex"
            >
              <!--            <p class="dmessageIcon" v-if="index == 0">盐湖区精品</p>-->
              <img :src="goodsItem.imgUrl" alt="" />
              <div class="sdmessagesbotMes">
                <div class="flex brandBox">
                  <p class="brand" v-if="goodsItem.brand">
                    {{ goodsItem.brand }}
                  </p>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="goodsItem.name"
                    placement="bottom"
                  >
                    <h4>{{ goodsItem.name }}</h4>
                  </el-tooltip>
                </div>
                <p>{{ goodsItem.shopName }}</p>
                <span>{{ goodsItem.minPrice }}元</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 水泵成品循环数据 -->
        <div
          v-if="item.fileList.length > 0"
          class="swiperTop dmessages"
          :ref="'accessories' + index"
          :key="index"
        >
          <div
            class="flex swiperTopTitle"
            style="margin-bottom: 16px;align-items: center;"
          >
            <div class="flex tabSwiper">
              <div class="flex swiperTopTitleIcon">
                <!-- <p>{{ index+1 }}</p>
                <img src="../../assets/mallTitle.png" alt=""> -->
                <h2>{{ item.categoryName }}</h2>
              </div>
              <div class="flex titleRight" v-if="item.categoryList.length > 0">
                <span
                  v-for="(category, categoryIndex) in item.categoryList"
                  @click="handGoodsList(category.parentUuid, category.uuid)"
                  :key="categoryIndex"
                >
                  {{ category.name }}
                  <span
                    class="titleXie"
                    v-if="categoryIndex + 1 < item.categoryList.length"
                    >/</span
                  >
                </span>
              </div>
            </div>
            <div @click="handGoodsList(item.categoryUuid)" class="moreText">
              查看更多 >
            </div>
          </div>
          <div class="dmessBox">
            <img
              v-for="(file, indexs) in item.fileList"
              :src="file.path"
              alt=""
              class="dmessagesImgLeft"
            />
            <div class="dmessagesBottom dmessagesboxImg">
              <div
                class="dmessagesBottombox"
                @click="handGoodsDetails(goods.uuid)"
                v-for="(goods, goodsIndex) in item.goodsList.slice(0, 8)"
                :key="goodsIndex"
              >
                <img :src="goods.imgUrl" alt="" />
                <div class="sdmessagesbotMes">
                  <div class="flex brandBox">
                    <p class="brand" v-if="goods.brand">{{ goods.brand }}</p>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="goods.name"
                      placement="bottom"
                    >
                      <h4>{{ goods.name }}</h4>
                    </el-tooltip>
                  </div>
                  <p>{{ goods.shopName }}</p>
                  <span>{{ goods.minPrice }}元</span>
                </div>
              </div>
              <div style="width: 230px;height: 0;" v-for="item in 4"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 推荐商家 -->
      <div class="goods" ref="merchants">
        <div class="goodsbox">
          <div class="flex swiperTopTitle">
            <div class="flex swiperTopTitleIcon">
              <!-- <p>{{ tabsNap.length+1 }}</p>
              <img src="../../assets/mallTitle.png" alt=""> -->
              <h2>推荐商家</h2>
            </div>
            <div class="titleMore" @click="handMallList">查看更多 ></div>
          </div>
          <div class="goodsImg flex">
            <div
              v-for="(items, index) in merchants"
              :key="index"
              class="goodsImgBox"
            >
              <img
                :src="items.logo"
                v-if="items.logo != ''"
                alt=""
                @click="
                  goToDetail(
                    items.storeUuid,
                    items.storeUuid,
                    items.enterpriseUuid
                  )
                "
              />
              <img
                src="../../assets/storeLogo.jpeg"
                v-else
                alt=""
                @click="
                  goToDetail(
                    items.storeUuid,
                    items.storeUuid,
                    items.enterpriseUuid
                  )
                "
              />
              <div class="mask">
                <div class="maskContent">
                  <p style="font-size: 14px; ">{{ items.enterPriseName }}</p>
                  <p
                    style="
                        font-size: 12px;
                        color: #fff;
                        display: flex;
                        padding: 5px 10px 0"
                  >
                    <span>好评度：</span>
                    <el-rate
                      v-model="items.star"
                      disabled
                      :colors="colors"
                    ></el-rate>
                  </p>
                </div>
              </div>
            </div>
            <!-- <p class="noMess">
              <img src="../../assets/noMesge.jpg" alt="" style="height:200px" />
            </p> -->
          </div>
        </div>
      </div>
      <div class="topNapbox" v-show="isScroll">
        <div class="topNap">
          <p
            @click="getTitleDistance(index)"
            v-for="(items, index) in tabsNap"
            :class="distanceIndex == index ? 'active' : ''"
            :key="index"
          >
            {{ items.categoryName }}
          </p>
          <p
            @click="getTitleDistance(tabsNap.length)"
            :class="distanceIndex == tabsNap.length ? 'active' : ''"
          >
            推荐商家
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getShopList,
  getNewcurrent,
  findRecommendList,
  getShopRecommendList,
  getShopCarNumber,
  getShopRecommendDetail,
  typeTree,
  getDictionaryItem,
  getBannerList,
} from "../../utils/interface"
import Swiper from "swiper"
import { mapState, mapMutations } from "vuex"
import { forEach } from "jszip"

export default {
  //   宁夏工业企业数字化转型公共服务平台商
  name: "threeShop",
  metaInfo: {
    title:
      "宁夏工业企业数字化转型公共服务平台商-提供水泵行业优质零部件及产品资源-宁夏工业企业数字化转型公共服务平台", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "宁夏工业企业数字化转型公共服务平台|水泵行业供需对接平台|盐湖区水泵企业|盐湖区水泵产业链 | 水泵配件 | 水泵零部件采购",
      },
      {
        // set meta
        name: "description",
        content:
          "宁夏工业企业数字化转型公共服务平台商平台汇聚水泵行业优质零部件及产品资源，为水泵企业提供从产品展示到采购交易的一站式服务。",
      },
    ],
  },
  components: {},
  data() {
    return {
      imgurlList: [],
      colors: ["#da251d", "#da251d", "#da251d"],
      keywords: [],
      show: false,
      //二级分类列表
      firstLists: [],
      firstUuids: "",
      bannerList: [],
      searchValue: "",
      distanceIndex: 0,
      isScroll: false,
      setIn: null,
      tabsNap: [],
      // 优质商家
      merchants: [],
      // 商家入驻信息
      identity: "",
      firstList: [],
      adBanner: "",
      adBannerLink: "",
      rightTopBanner: "",
      rightBottomBanner: "",
      rightTopBannerLink: "",
      rightBottomBannerLink: "",
      rightCenterBanner: "",
      rightCenterBannerLink: "",
      isShow: false,
      goodsNum: 0,
      num: 0,
      activeName: "1",
    }
  },
  mounted() {
    this.handSwiper()
    window.addEventListener("scroll", this.handleScroll, true)
  },
  created() {
    this.getShopCarNumber()
    this.getShopRecommendList()
    this.findRecommendList()
    this.getShopCategoryList()
    this.getBannerMesgList()
    getDictionaryItem({ groupCode: "shop_keyword" }).then((res) => {
      if (res != null && res.length > 0) {
        res.forEach((item, index) => {
          this.keywords.push(item.name)
        })
      }
    })
    getDictionaryItem({ groupCode: "SHOP_BANNER" }).then((res) => {
      this.bannerList = res
    })
    getDictionaryItem({ groupCode: "SHOP_BANNER_RIGHT_TOP" }).then((res) => {
      if (res.length > 0) {
        this.rightTopBanner = res[0].value
        this.rightTopBannerLink = res[0].linkUrl
      }
    })
    getDictionaryItem({ groupCode: "SHOP_BANNER_RIGHT_BOTTOM" }).then((res) => {
      if (res.length > 0) {
        this.rightBottomBanner = res[0].value
        this.rightBottomBannerLink = res[0].linkUrl
      }
    })
    getDictionaryItem({ groupCode: "SHOP_BANNER_RIGHT_MIDDLE" }).then((res) => {
      if (res.length > 0) {
        this.rightCenterBanner = res[0].value
        this.rightCenterBannerLink = res[0].linkUrl
      }
    })
    getDictionaryItem({ groupCode: "SHOP_AD_BANNER" }).then((res) => {
      if (res.length > 0) {
        this.adBanner = res[0].value
        this.adBannerLink = res[0].linkUrl
      }
    })
    // this.setIn = setInterval(() => {
    //   if (this.isTokenDoor === true) {
    //     clearInterval(this.setIn);
    //   }
    // }, 500);
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
      isLogin: "isLogin",
    }),
  },
  methods: {
    // 背景图
    getBannerMesgList() {
      getBannerList({
        groupCode: "SHOP_BEIJING",
      }).then((res) => {
        this.imgurlList = res
      })
    },
    sentimenClick(type) {
      let addList = this.tabsNap[0].goodsList
      if (addList.length <= 5) {
        return
      } else {
        if (type == "left") {
          if (addList.length - 1 > this.num) {
            ++this.num
          }
        } else {
          --this.num
        }
        if (addList.length / 5 < this.num) {
          this.num = --this.num
          return
        }
        if (this.num == -1) {
          this.num = ++this.num
          return
        }

        if (type == "left") {
          if (230 * Number(addList.length - 1) > Math.abs(this.num * -1200)) {
            let leftNum = this.num * -1200 + "px"
            this.$refs.dmessageRef[0].style.transform = `translate(${leftNum},0)`
          }
        } else if (type == "right") {
          if (this.num * -1200 <= 0) {
            let rightNum = this.num * -1200 + "px"
            this.$refs.dmessageRef[0].style.transform = `translate(${rightNum},0)`
          }
        }
      }
    },
    handleClick() {},
    getShopCarNumber() {
      if (this.isLogin) {
        this.isShow = true
        getShopCarNumber().then((res) => {
          if (res.success) {
            this.goodsNum = res.data
          }
        })
      } else {
        this.isShow = false
      }
    },
    searchByKeyword(keyword) {
      this.searchValue = keyword
      let routeData = this.$router.resolve({
        name: "shopGoodsList",
        query: { keywords: this.searchValue },
      })
      window.open(routeData.href, "_blank") // 新窗口打开外链接
    },
    getShopList() {
      let routeData = this.$router.resolve({
        name: "shopGoodsList",
        query: {
          keywords: this.searchValue,
        },
      })
      // console.log(JSON.stringify(routeData));
      window.open(routeData.href, "_blank") // 新窗口打开外链接
    },
    btnChoose(uuid, item) {
      this.firstUuids = uuid
      this.firstLists = []
      this.show = true
      this.firstLists = item
    },
    leave() {
      this.show = false
      this.firstUuids = ""
      this.firstLists = []
    },
    async getShopRecommendList() {
      let arr = []
      this.tabsNap = []
      let res = await getShopRecommendList()

      res.forEach((item) => {
        let result = getShopRecommendDetail(item.uuid)
        arr.push(result)
      })
      let allList = await Promise.all(arr)
      allList.forEach((item, index) => {
        res[index].goodsList = item.length ? item : []
      })
      this.tabsNap = res
    },
    getShopCategoryList() {
      let params = {
        grade: "3",
        type: "PLATFORM",
      }
      typeTree(params).then((res) => {
        this.firstList = res
        // console.log(this.firstList)
      })
    },
    findRecommendList() {
      let params = {
        current: 1,
        pageSize: 6,
        isRecommend: 1,
      }
      findRecommendList(params).then((res) => {
        this.merchants = res.list
      })
    },
    ...mapMutations(["isLoginVuex"]),
    // 判断当前用户是否可以进行商家
    // 商家入驻
    toServiceAuthentication() {
      if (this.$store.state.isLogin) {
        getNewcurrent().then((data) => {
          this.identity = data.identity
          if (this.identity === "ENTERPRISE") {
            this.$router.push({
              name: "shopServiceAuthentication",
            })
          } else if (
            this.identity === "PERSONAL" ||
            this.identity === "ANONYMOUS"
          ) {
            this.$confirm("请先进行企业资质认证!", "提示", {
              confirmButtonText: "去认证",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              window.sessionStorage.setItem("userServeId", "11")
              let routeData = this.$router.resolve({
                name: "userCenter",
                params: {
                  userServeId: "11",
                },
              })
              window.open(routeData.href, "_target")
            })
          }
        })
      } else {
        this.$message({
          type: "error",
          message: "您需要先登录哦！",
        })
        this.$router.push("/login")
        return false
      }
    },
    handSwiper() {
      new Swiper(".swiper-container", {
        // slidesPerView: 5,
        // spaceBetween: 30,
        // slidesPerGroup: 3,
        // loop: true,
        // loopFillGroupWithBlank: true,
        // // 如果需要分页器
        // pagination: {
        //   el: ".swiper-pagination",
        // },

        slidesPerView: 5, //显示个数
        pagination: {
          el: ".swiper-pagination",
        },
        // // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      })
    },
    getTitleDistance(i) {
      this.distanceIndex = i
      // console.log(333333333,  this.distanceIndex)
      if (this.tabsNap.length == i) {
        let merchants = this.$refs.merchants
        window.scrollTo({
          top: merchants.offsetTop - 80,
          behavior: "smooth",
        })
      } else {
        if (this.tabsNap[i].fileList.length == 0) {
          window.scrollTo({
            top: this.$refs.newmess[i].offsetTop - 80,
            behavior: "smooth",
          })
        } else {
          let accessRefs = eval("this.$refs.accessories" + i)
          window.scrollTo({
            top: accessRefs[0].offsetTop - 80,
            behavior: "smooth",
          })
        }
      }
    },
    // 商品列表
    handGoodsList(firstUuid, secondUuid, thirdUuid) {
      let routeData
      if (firstUuid == undefined && secondUuid == undefined) {
        routeData = this.$router.resolve({
          name: "shopGoodsList",
        })
      } else {
        routeData = this.$router.resolve({
          name: "shopGoodsList",
          params: {
            uuid: firstUuid,
            secondUuid: secondUuid,
            thirdUuid: thirdUuid,
          },
        })
      }
      window.open(routeData.href, "_blank")
    },
    openNewPage(linkUrl) {
      window.open(linkUrl, "_target")
    },
    // 商品详情
    handGoodsDetails(uuid) {
      let routeData = this.$router.resolve({
        name: "shopGoodDetails",
        params: { uuid: uuid },
      })
      window.open(routeData.href, "_blank")
    },
    // 商城列表
    handMallList() {
      let routeData = this.$router.resolve({
        name: "shopMallList",
        params: { url: "shopMallList" },
      })
      window.open(routeData.href, "_blank")
    },
    // 进店看看
    goToDetail(uuid, storeUuid, enterpriseUuid) {
      // uuid 店铺信息
      // enterPriseUuid 企业id
      // 跳转到详情页
      let routeData = this.$router.resolve({
        name: "printServiceIndex",
        params: {
          uuid: uuid,
          storeUuid: storeUuid,
          enterPriseId: enterpriseUuid,
        },
      })
      window.open(routeData.href, "_blank")
    },
    // 滚动固定导航栏
    handleScroll() {
      this.$nextTick(() => {
        // 获取所有锚点元素
        const divs = [...document.querySelectorAll(".titleTit")]
        // 所有锚点元素的 offsetTop
        // console.log(divs)
        const offsetTopArr = []
        // 将所有锚点元素offsetTop push到数组内
        divs.forEach((item) => {
          offsetTopArr.push(item.offsetTop - 120)
        })
        // 获取当前文档流的 scrollTop
        const scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop

        // 定义当前点亮的导航下标
        let navIndex = 0
        for (let n = 0; n < offsetTopArr.length; n++) {
          // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
          // 那么此时导航索引就应该是 n 了
          if (scrollTop >= offsetTopArr[n]) {
            navIndex = n
          }
        }
        // 把下标赋值给 vue 的 data
        this.distanceIndex = navIndex

        // let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        //变量windowHeight是可视区的高度
        let windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight
        //变量scrollHeight是滚动条的总高度
        let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight
        if (scrollTop > 450 && scrollTop + windowHeight < scrollHeight) {
          this.isScroll = true
        } else {
          this.isScroll = false
        }
        if (
          this.$refs.newmess &&
          this.$refs.equipment &&
          this.$refs.accessories &&
          this.$refs.consumables &&
          this.$refs.goods &&
          this.$refs.merchants
        ) {
          let detailsTops1Height = this.$refs.newmess.offsetHeight
          let detailsTops2Height = this.$refs.equipment.offsetHeight
          let detailsTops3Height = this.$refs.accessories.offsetHeight
          let detailsTops4Height = this.$refs.consumables.offsetHeight
          let detailsTops5Height = this.$refs.goods.offsetHeight
          if (scrollTop > 450 && scrollTop < 480 + detailsTops1Height) {
            this.distanceIndex = 0
          } else if (
            scrollTop > 480 + detailsTops1Height &&
            scrollTop < 530 + detailsTops1Height + detailsTops2Height
          ) {
            this.distanceIndex = 1
          } else if (
            scrollTop > 530 + detailsTops1Height + detailsTops2Height &&
            scrollTop <
              600 + detailsTops1Height + detailsTops2Height + detailsTops3Height
          ) {
            this.distanceIndex = 2
          } else if (
            scrollTop >
              600 +
                detailsTops1Height +
                detailsTops2Height +
                detailsTops3Height &&
            scrollTop <
              680 +
                detailsTops1Height +
                detailsTops2Height +
                detailsTops3Height +
                detailsTops4Height
          ) {
            this.distanceIndex = 3
          } else if (
            scrollTop >
              680 +
                detailsTops1Height +
                detailsTops2Height +
                detailsTops3Height +
                detailsTops4Height &&
            scrollTop <
              750 +
                detailsTops1Height +
                detailsTops2Height +
                detailsTops3Height +
                detailsTops4Height +
                detailsTops5Height
          ) {
            this.distanceIndex = 4
          } else {
            this.distanceIndex = 5
          }
        }
      })
    },
  },
}
</script>

<style scoped lang="less">
.noMess {
  width: 100%;
  text-align: center;
}

.softwareVendor {
  .softwareVendorTitle {
    text-align: center;
    margin-bottom: 30px;

    .printTitle {
      margin: 0;
      font-size: 24px;
      font-weight: bold;
      color: #2d2d2d;
    }

    .partnersPartClass {
      display: flex;
      align-items: center;
      width: 218px;
      margin: 0 auto;

      .line {
        width: 62px;
        height: 2px;
        background: #aaa;
      }

      .name {
        font-size: 16px;
        padding: 0 15px;
        color: #aaa;
        font-weight: normal;
      }
    }
  }

  /deep/ .el-col-4 {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }

  /deep/ .el-row {
    margin: 0 !important;
  }
}

.softMarketTop {
  width: 100%;
  // height: 110px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  z-index: 9;

  .softMarketTopSearch {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    padding-top: 18px;
    box-sizing: border-box;

    .logoTitle {
      font-size: 24px;
      // line-height: 74px;
      color: #009999;
      font-weight: bold;

      .logoTitle1 {
        height: 40px;
        color: #000;
      }

      .logoTitle2 {
        font-size: 18px;
        background: #535353;
        height: 40px;
        color: #fff;
        line-height: 40px;
        width: 246px;
        padding-left: 20px;
        box-sizing: border-box;
        margin-top: 6px;
        cursor: pointer;
      }
    }

    .searchContainer {
      // width: 690px;
      margin: 0 auto;
      padding: 0 15px;

      .searchContainerone {
        .input-with-select {
          flex-shrink: 0;
        }

        .searchContainerButton {
          color: #009999;
          margin-left: 60px;
          border: 1px solid #009999;
          background: #fff;
          font-size: 14px;
        }
      }

      /deep/ .input-with-select .el-input__inner {
        border: 2px solid #009999;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        background: #fdfdfd;
        height: 40px;
        line-height: 40px;
      }

      /deep/ .el-input-group {
        height: 40px;
        width: 618px;
      }

      /deep/ .input-with-select .el-input-group__append {
        background: #009999;
        color: #fff;
        border: 1px solid #009999;
        border-left: none;
        border-radius: 0px 20px 20px 0px;
        width: 80px;
        box-sizing: border-box;
        text-align: center;
      }

      ul {
        display: flex;
        align-items: center;
        color: #6e6e6e;
        padding-left: 3px;

        li {
          font-size: 12px;
          margin-top: 10px;
          padding: 0 15px;

          &.textLi {
            cursor: pointer;
            border-right: 1px solid #6e6e6e;

            &:hover {
              color: #009999;
            }
          }
          &.textLi:last-child {
            border: none !important;
          }
        }
      }
    }

    .shoppingCar {
      margin-top: 6px;
    }
  }
}
.softBox {
  position: relative;
  height: 497px;
}
.softMarketBanner {
  width: 100%;
  height: 380px;
  // background: url(../../assets/image/BannerBg.png) no-repeat 50%;
  // background-size: cover;
  padding-bottom: 13px;
  position: absolute;
  top: 104px;

  .bannerContainer {
    z-index: 9;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    //  .bannerContainerLeft:hover .softMarketDetails{
    //         display: block;
    //     }
    .bannerContainerBox {
      display: flex;
      padding: 10px;
    }

    .bannerContainerLeft {
      width: 246px;
      height: 380px;
      position: relative;
      box-sizing: border-box;

      .softMarketDetails {
        width: 668px;
        height: 344px;
        background-color: white;
        position: absolute;
        top: 0;
        left: 246px;
        z-index: 999;
        padding: 20px;
        cursor: pointer;
        // display: none;
        .softMarketList {
          display: flex;
          // align-items: center;
          flex-wrap: wrap;
          margin-bottom: 10px;
          font-size: 14px;

          .secondName {
            width: 100px;
            margin-right: 5px;
            color: #131313;
            text-align: left;

            span:hover {
              color: #009999;
            }

            span {
              cursor: pointer;
            }
          }

          .threeName {
            width: 360px;
            display: flex;
            flex-wrap: wrap;
            cursor: pointer;

            span:hover {
              color: #009999;
            }

            div {
              margin-right: 20px;
              margin-bottom: 10px;
              color: #c2c4c7;
            }
          }
        }
      }

      .softMarketClassifyTop {
        width: 100%;
        color: #fff;
        background: #063975;
        height: 362px;
        padding: 0 15px;
        line-height: 50px;
        box-sizing: border-box;
        font-size: 18px;
        font-weight: bold;
      }

      .softMarketClassifyContainer {
        width: 246px;
        height: 393px;

        ul {
          width: 246px;
          height: 393px;
          background: #fff;
          color: #3e3e3e;
          padding: 12px 21px;
          box-sizing: border-box;
          // overflow-y: scroll;
          &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
          }

          li {
            font-weight: 400px;
            margin-bottom: 6px;

            .secondItem {
              height: 22px;
              display: flex;
              flex-wrap: wrap;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;

              span {
                margin-right: 5px;
                color: #3e3e3e;

                &:hover {
                  color: #2d50a1;
                }
              }
            }

            .liSpan {
              font-size: 14px;
              cursor: pointer;
              color: #3e3e3e;
              font-weight: bold;
            }

            span {
              font-size: 12px;
              cursor: pointer;
            }
          }

          li:nth-last-of-type(1) {
            margin-bottom: 0;
          }
        }
      }
    }

    .bannerContainerCenter {
      width: 698px;
      // padding: 14px 0;
      flex-shrink: 0;
      box-sizing: border-box;
      position: relative;
      margin-right: 10px;

      /deep/ .el-carousel__indicator {
        button {
          opacity: 1;
          background: #fff;
          height: 5px;
          width: 5px;
          border-radius: 50%;
          &:hover {
            background: #009999;
          }
        }
        &.is-active {
          button {
            background: #009999;
            width: 20px !important;
            height: 5px !important;
            border-radius: 4px !important;
          }
        }
      }
      /deep/.el-carousel__indicators--horizontal {
        bottom: 9px;
      }
      .carouselBtn {
        background-color: rgba(0, 0, 0, 0.4);
        width: 100%;
        height: 48px;
        position: absolute;
        bottom: 0;
      }

      .bannerContainerBottom {
        display: flex;
        padding-top: 17px;
        justify-content: space-between;
        flex-wrap: wrap;

        img {
          width: 218px;
          height: 88px;
          // margin-right: 6px;
        }

        .bannerContainerBottomimg {
          width: 218px;
          height: 0;
        }
      }
    }

    .bannerContainerCenterImg {
      width: 236px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      a {
        width: 236px;
        height: 121px;
        display: inline-block;
      }

      img {
        width: 236px;
        height: 121px;
        background: #efefef;
      }
    }

    .box-card {
      border: 1px solid #e3e3e3;
      margin-bottom: 30px;
      font-size: 12px;

      h2 {
        font-size: 16px;
        margin-bottom: 5px;
      }

      .sDetail {
        font-size: 12px;
        margin: 15px auto;
        text-align: left;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        color: #858993;
      }

      .sPrice {
        font-size: 16px;
        color: #da251d;
        margin-bottom: 15px;

        span {
          font-size: 12px;
        }
      }

      .image {
        width: 64px;
        height: 64px;
        margin-top: 15px;
      }
    }
  }
}

.shopBox {
  // padding-top: 30px;
  margin-top: 18px;
}

.bannerBox {
  margin: 0 auto 18px;
  width: 1200px;
  height: 130px;

  .bannerMsg {
    width: 100%;
    height: 130px;
    object-fit: cover;
  }
}

.swiperTop {
  width: 1245px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 65px;

  .swiperTopTitle {
    justify-content: space-between;
    align-items: center;
    // border-bottom: 1px solid #e3e3e3;
    box-sizing: border-box;

    h2 {
      font-size: 18px;
      height: 28px;
      color: #000;
    }

    .moreText {
      font-size: 13px;

      &:hover {
        color: #009999;
        cursor: pointer;
      }
    }

    .peopelMess {
      i {
        border-radius: 50%;
        display: inline-block;
        width: 21px;
        height: 21px;
        line-height: 21px;
        text-align: center;
        color: #fff;
        margin-left: 9px;
        font-size: 12px;
        font-weight: bold;
        cursor: pointer;
        background: #d3d3d3;

        &:hover {
          background: #009999;
          color: #fff;
        }
      }
    }
  }

  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    cursor: pointer;

    img {
      width: 195px;
      height: 130px;
      background: #efefef;
      display: block;
    }

    .swiper-slideMess {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 195px;
      height: 72px;
      background: #f5f5f5;

      h4 {
        font-size: 16px;
        color: #0f1826;
      }

      p {
        font-size: 10px;
        color: #0f1826;
      }

      span {
        font-size: 12px;
        color: #ff0000;
      }
    }

    &:hover {
      img {
        box-shadow: 0px 0px 17px -7px #707070;
      }

      .swiper-slideMess {
        background: #009999;

        h4 {
          color: #fff;
        }

        p {
          color: #fff;
        }

        span {
          color: #fff;
        }
      }
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    width: 40px;
    height: 40px;
    background: #e5e5e52e;
    border-radius: 50%;
    top: 200px;
  }

  .swiper-button-prev {
    left: -18px;
  }

  .swiper-button-next {
    right: -18px;
  }

  .swiper-button-prev:after,
  .swiper-container-rtl .swiper-button-next:after {
    font-size: 18px;
  }

  .swiper-button-next:after,
  .swiper-container-rtl .swiper-button-prev:after {
    font-size: 18px;
  }
}
.titleMore {
  font-size: 13px;

  &:hover {
    color: #009999;
    cursor: pointer;
  }
}
.swiperTopTitleIcon {
  p {
    align-items: center;
    height: 32px;
    width: 32px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    line-height: 32px;
    background-color: #009999;
    margin-right: 3px;
  }
  img {
    height: 32px;
    margin-right: 15px;
  }
}
.dmessages {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 18px;

  .swiperTopTitle {
    justify-content: space-between;
    align-items: center;

    h2 {
      font-size: 18px;
      color: #000;
    }

    .titleRight {
      align-items: flex-end;
      height: 20px;

      i {
        color: #444444;
        margin-left: 110px;
        cursor: pointer;
      }

      span {
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
      }

      .titleXie {
        margin: 0 5px;
      }
    }
  }

  .dmessagesImg {
    width: 100%;
    height: 300px;
    background: #efefef;
    margin: 28px 0 31px 0;

    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }

  .dmessBox {
    display: flex;

    .dmessagesImgLeft {
      width: 233px;
      height: 525px;
      margin-right: 9px;
    }
  }

  .dmessagesboxImg {
    flex-wrap: wrap;
    justify-content: space-between;
    height: 246px;

    .dmessagesBottombox {
      margin-left: 0 !important;
      margin-bottom: 14px;
    }
  }

  .dmessagesBottom {
    display: flex;
    width: 1200px;
    // height: 402px;

    .dmessagesBottombox:nth-of-type(1) {
      margin-left: 0px;
    }

    .dmessagesBottombox {
      margin-left: 12px;
      background: #fff;
      position: relative;
      // height: 400px;

      .dmessageIcon {
        width: 64px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        background: #e6f4ff;
        border-radius: 4px;
        border: 1px solid rgba(0, 153, 153, 0.4);
        font-size: 12px;
        color: #009999;
        position: absolute;
        top: 10px;
        left: 10px;
      }

      img {
        width: 230px;
        height: 171px;
        display: inline-block;
        background: #efefef;
        display: block;
        cursor: pointer;
      }

      .sdmessagesbotMes {
        cursor: pointer;
        width: 100%;
        height: 80px;
        color: #0f1826;
        text-align: center;
        background: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: 4px;
        .brandBox {
          justify-content: center;
          align-items: center;
          width: 210px;
        }
        h4 {
          // width: 80%;
          font-size: 16px;
          // margin-top: 6px;
          margin-bottom: 6px;
          font-weight: normal;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        p {
          // font-size: 10px;
          // font-weight: 400;
          font-size: 12px;
          color: #585858;
          margin-bottom: 6px;
        }

        span {
          font-size: 12px;
          font-weight: bold;
          color: #ff0000;
        }
      }
    }

    .dmessagesBottombox:hover {
      box-shadow: 0 0 10px 4px #c7c7c77e;

      .sdmessagesbotMes {
        background: #79cdcd;
        color: #fff;

        span {
          color: #fff;
        }
      }

      p {
        color: #fff !important;
      }
      .brand {
        background: rgba(255, 149, 0);
      }

      .dmessageIcon {
        color: #009999;
      }
    }
  }

  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    cursor: pointer;

    img {
      width: 195px;
      height: 130px;
      background: #efefef;
      display: block;
    }

    .swiper-slideMess {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 195px;
      height: 72px;
      background: #f5f5f5;

      h4 {
        font-size: 16px;
        color: #0f1826;
      }

      p {
        font-size: 10px;
        color: #0f1826;
      }

      span {
        font-size: 12px;
        color: #ff0000;
      }
    }

    &:hover {
      img {
        box-shadow: 0px 0px 17px -7px #707070;
      }

      .swiper-slideMess {
        background: #009999;

        h4 {
          color: #fff;
        }

        p {
          color: #fff !important;
        }
        .brand {
          background: rgba(255, 149, 0);
        }
        span {
          color: #fff;
        }
      }
    }
  }
}

.tabSwiper {
  align-items: baseline;

  h2 {
    margin-right: 40px;
  }

  /deep/ .el-tabs__nav-wrap::after {
    background-color: transparent;
  }

  /deep/ .el-tabs__header {
    margin: 0;
  }

  /deep/ .el-tabs__item:hover {
    color: #009999;
  }

  /deep/ .el-tabs__item.is-active {
    color: #009999;
  }

  /deep/ .el-tabs__active-bar {
    background-color: #009999;
  }
}

.goods {
  .goodsbox {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0 26px;
    padding-top: 0;

    .swiperTopTitle {
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;

      .titleMore {
        font-size: 13px;

        &:hover {
          color: #009999;
          cursor: pointer;
        }
      }

      h2 {
        font-size: 18px;
        color: #000;
      }

      i {
        color: #444444;
        cursor: pointer;
      }
    }
  }

  .goodsImg {
    flex-wrap: wrap;
    // justify-content: space-between;
    .goodsImgBox:nth-of-type(6n + 1) {
      margin-left: 0;
    }

    .goodsImgBox {
      // width: 189px;
      // height: 0;
      margin-left: 13px;
      position: relative;
    }

    img:nth-child(1) {
      margin-left: 0;
    }

    img {
      width: 189px;
      height: 90px;
      background: #efefef;
      margin-bottom: 13px;
      cursor: pointer;
      box-shadow: 0px 0px 5px 2px #efefef;
    }
  }
}

.topNapbox {
  margin: 0 auto;
  top: 100px;
  // left: 16%;
  left: 9%;
  // transform: translate(-56%, 0);
  position: fixed;
  z-index: 10;
  box-shadow: 0 3px 10px #d3d3d3;
  .topNap {
    width: 60px;
    // height: 387px;
    background: #fbfbfb;
    padding: 23px 0 9px;
    box-sizing: border-box;
    text-align: center;
    p {
      width: 41px !important;
    }

    p:nth-child(1) {
      width: 41px;
    }

    p:nth-last-child(1) {
      width: 41px;
    }

    p:nth-child(4) {
      width: 47px;
    }

    p {
      padding: 0 7px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      color: #707070;
      display: block;
      // text-align: left;
      margin-bottom: 17px;
      // &:nth-last-of-type(1) {
      //   margin-bottom: 0;
      //   color: #009999;
      //   i {
      //     display: block;
      //     margin-bottom: 9px;
      //   }
      // }
      &.active {
        // color: #fff !important;
        // background: #009999;
        color: #009999;
      }

      &:hover {
        color: #009999;
      }
    }
  }
}

.mask {
  position: absolute;
  background: rgba(101, 101, 101, 0.6);
  color: #ffffff;
  opacity: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 90px;
  border-radius: 10px;
  pointer-events: none;

  .maskContent {
    position: absolute;
    top: 50%;
    width: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  p {
    text-align: center;
  }
}

.goodsImgBox:hover .mask {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/threeShop/index.vue